/* SQINWEAR · Slider de fotos en tarjetas de producto */
(function () {
  var ARROW = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor"/></svg>';

  function setup(media) {
    if (media.dataset.sqinSlider) return;
    var slider = media.querySelector('.mobile-product-slider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.mobile-product-slide');
    media.dataset.sqinSlider = '1';
    if (slides.length < 2) return;

    media.classList.add('sqin-has-slider');
    media.classList.remove('has-hover');

    var n = slides.length;
    var bar = document.createElement('div');
    bar.className = 'sqin-card-bar';
    bar.innerHTML = '<span style="width:' + (100 / n) + '%"></span>';
    media.appendChild(bar);
    var thumb = bar.firstChild;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'sqin-card-arrow sqin-card-arrow--prev';
    prev.setAttribute('aria-label', 'Foto anterior');
    prev.innerHTML = ARROW.replace('<svg', '<svg style="transform:rotate(180deg)"');
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'sqin-card-arrow sqin-card-arrow--next';
    next.setAttribute('aria-label', 'Foto siguiente');
    next.innerHTML = ARROW;
    media.appendChild(prev);
    media.appendChild(next);

    function index() {
      var w = slider.clientWidth || 1;
      return Math.max(0, Math.min(n - 1, Math.round(slider.scrollLeft / w)));
    }
    function update() {
      var i = index();
      thumb.style.transform = 'translateX(' + (i * 100) + '%)';
      prev.disabled = i === 0;
      next.disabled = i === n - 1;
    }
    function go(dir, e) {
      e.preventDefault();
      e.stopPropagation();
      slider.scrollTo({ left: (index() + dir) * slider.clientWidth, behavior: 'smooth' });
    }
    prev.addEventListener('click', function (e) { go(-1, e); });
    next.addEventListener('click', function (e) { go(1, e); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });

    /* Evita abrir el producto si el gesto ha sido un deslizamiento */
    var startX = 0, moved = false;
    slider.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
    slider.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - startX) > 8) moved = true; });
    media.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);

    update();
  }

  function init(root) {
    (root || document).querySelectorAll('.card-product__media').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Tarjetas cargadas después (cargar más, filtros, recomendaciones) */
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { init(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* SQINWEAR · Ficha de producto: talla sin preseleccionar; el botón pide la talla hasta que se elige */
(function () {
  if (!document.body.classList.contains('template--product')) return;

  var BTN = 'product-form button[name="add"], product-bar button[name="add"]';

  function sizeGate() {
    if (new URLSearchParams(location.search).has('variant')) return; /* enlace a una talla concreta: se respeta */
    var root = document.querySelector('.product__selector');
    if (!root || root.dataset.sqinGate) return;
    var sets = root.querySelectorAll('fieldset');
    if (sets.length !== 1) return; /* solo productos con una única opción (talla) */
    var radios = sets[0].querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;
    root.dataset.sqinGate = '1';

    var chosen = false;
    radios.forEach(function (r) {
      r.checked = false;
      r.removeAttribute('checked');
    });
    sets[0].querySelectorAll('label').forEach(function (l) { l.classList.remove('is-active'); });

    /* "Elige tu talla" en el botón (se pinta por CSS para no chocar con el script que añade el precio) */
    function paint() {
      document.querySelectorAll(BTN).forEach(function (b) {
        b.classList.toggle('sqin-btn-choose', !chosen);
      });
    }
    paint();

    function markChosen() {
      chosen = true;
      paint();
    }
    radios.forEach(function (r) { r.addEventListener('change', markChosen); });
    var barSelect = document.querySelector('product-bar select[name^="options["]');
    if (barSelect) barSelect.addEventListener('change', markChosen);
    document.querySelectorAll('product-bar .dropdown__item-button:not(.pdp-quiz-slot-button)').forEach(function (b) {
      b.addEventListener('click', markChosen);
    });

    /* Sin talla elegida, el botón solo lleva a las tallas */
    function block(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    document.addEventListener('click', function (e) {
      if (chosen) return;
      var b = e.target.closest && e.target.closest(BTN);
      if (b) block(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (chosen) return;
      var f = e.target;
      if (f && f.matches && f.matches('form[action*="/cart/add"]') && f.closest('product-form, product-bar')) block(e);
    }, true);
  }

  /* Bloqueo de talla DESACTIVADO (prueba 24/09): para reactivarlo, volver a llamar a sizeGate() */
})();

/* SQINWEAR · Ficha de producto: Descripción / Envíos / Cuidados / Guía de tallas en pestañas (en el mismo sitio) */
(function () {
  if (!document.body.classList.contains('template--product')) return;

  /* Descripción: resumen de ~22 palabras con "Leer más" / "Leer menos" */
  function summary(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var parts = [];
    tmp.querySelectorAll('li, p').forEach(function (el) {
      if (el.querySelector('li, p')) return;
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      if (!t) return;
      if (!/[.!?:]$/.test(t)) t += '.';
      parts.push(t);
    });
    var words = parts.join(' ').split(' ');
    if (words.length <= 25) return null;
    return words.slice(0, 22).join(' ').replace(/[.,;:]$/, '') + '…';
  }
  function moreBtn(label, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sqin-ptabs__more';
    b.textContent = label;
    b.addEventListener('click', onClick);
    return b;
  }
  /* Pinta el contenido de una pestaña; la de Descripción sale resumida */
  function render(panel, tab) {
    var short = /descrip/i.test(tab.title) ? summary(tab.html) : null;
    if (!short) { panel.innerHTML = tab.html; return; }
    function collapsed() {
      panel.innerHTML = '';
      var p = document.createElement('p');
      p.appendChild(document.createTextNode(short + ' '));
      p.appendChild(moreBtn('Leer más', expanded));
      panel.appendChild(p);
    }
    function expanded() {
      panel.innerHTML = tab.html;
      var p = document.createElement('p');
      p.appendChild(moreBtn('Leer menos', collapsed));
      panel.appendChild(p);
    }
    collapsed();
  }
  window.sqinRenderTab = render;

  function build() {
    var host = document.querySelector('.section-complete-the-set .section__buttons');
    if (!host || host.dataset.sqinTabs) return;
    var tabs = [];
    host.querySelectorAll('menu-drawer').forEach(function (md) {
      var t = md.querySelector('.drawer__button-text');
      var body = md.querySelector('.drawer__content .rte');
      if (t && body) tabs.push({ title: t.textContent.trim(), html: body.innerHTML });
    });
    /* Orden: Descripción, Guía de tallas, Envíos, resto */
    tabs.forEach(function (t) { if (/env[ií]o/i.test(t.title)) t.title = 'Envíos'; });
    var guide = document.querySelector('#Size-Guide-menu-drawer .rte');
    if (guide) tabs.splice(Math.min(1, tabs.length), 0, { title: 'Guía de tallas', html: guide.innerHTML });
    var ei = -1;
    tabs.forEach(function (t, i) { if (t.title === 'Envíos') ei = i; });
    if (ei > 2) tabs.splice(2, 0, tabs.splice(ei, 1)[0]);
    if (!tabs.length) return;
    host.dataset.sqinTabs = '1';

    var box = document.createElement('div');
    box.className = 'sqin-ptabs';
    var nav = document.createElement('div');
    nav.className = 'sqin-ptabs__nav';
    nav.setAttribute('role', 'tablist');
    var panel = document.createElement('div');
    panel.className = 'sqin-ptabs__panel rte';
    panel.setAttribute('role', 'tabpanel');
    tabs.forEach(function (tab, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.className = 'sqin-ptabs__btn' + (i === 0 ? ' is-active' : '');
      b.textContent = tab.title;
      b.addEventListener('click', function () {
        nav.querySelectorAll('.sqin-ptabs__btn').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        render(panel, tab);
        b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      nav.appendChild(b);
    });
    render(panel, tabs[0]);
    box.appendChild(nav);
    box.appendChild(panel);
    host.appendChild(box);
    host.classList.add('sqin-ptabs-host');
    /* La guía de tallas ya está en las pestañas: fuera el enlace junto a las tallas */
    document.body.classList.add('sqin-has-ptabs');
  }

  if (document.readyState === 'complete') build();
  else window.addEventListener('load', build);
})();

/* SQINWEAR · Klarna: a veces su servicio responde "sin contenido" y el mensaje no sale; se le vuelve a pedir */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function retry(k, n) {
    setTimeout(function () {
      var sr = k.shadowRoot;
      var empty = !sr || sr.innerHTML.length < 200;
      var amount = k.getAttribute('data-purchase-amount');
      if (!empty || !amount) return;
      k.setAttribute('data-purchase-amount', String(Number(amount) + 1));
      setTimeout(function () { k.setAttribute('data-purchase-amount', amount); }, 300);
      if (n < 3) retry(k, n + 1);
    }, n === 0 ? 2500 : 3000);
  }
  function run() { document.querySelectorAll('klarna-placement').forEach(function (k) { retry(k, 0); }); }
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();

/* SQINWEAR · Barra fija en packs con dos tallas: solo añade al carrito cuando se han elegido las dos */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  var SEL = 'product-bar select[name^="options["]';
  function dropdowns(bar) { return bar ? bar.querySelectorAll('dropdown-input') : []; }

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches(SEL)) return;
    var dd = s.closest('dropdown-input');
    if (dd) dd.classList.add('sqin-picked');
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('product-bar .product-bar__submit, product-bar button[name="add"]');
    if (!b) return;
    var dds = dropdowns(b.closest('product-bar'));
    if (dds.length < 2) return;
    var pending = Array.prototype.filter.call(dds, function (d) { return !d.classList.contains('sqin-picked'); });
    if (!pending.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    /* abre el siguiente selector que falta */
    setTimeout(function () {
      var det = pending[0].querySelector('details');
      if (det && !det.open) { var sum = det.querySelector('summary'); if (sum) sum.click(); }
    }, 150);
  }, true);
})();

/* SQINWEAR · Packs con dos tallas: la recomendación de talla va debajo de los dos selectores */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function fixReco() {
    var sets = document.querySelectorAll('.product__selector .product-selector__buttons');
    if (sets.length < 2) return;
    var reco = document.querySelector('.pdp-size-reco');
    var last = sets[sets.length - 1];
    if (reco && last.nextSibling !== reco) last.parentNode.insertBefore(reco, last.nextSibling);
  }
  window.addEventListener('load', function () { fixReco(); setTimeout(fixReco, 1000); setTimeout(fixReco, 2000); });
  setTimeout(fixReco, 1600);
})();

/* SQINWEAR · Compra rápida en tarjetas: los packs con dos tallas llevan a la ficha para elegir ambas */
(function () {
  function multi(b) { return (b.dataset.size || '').indexOf(' / ') !== -1; }
  function label() {
    document.querySelectorAll('.js-btn-size').forEach(function (b) {
      if (multi(b) && !b.dataset.sqinMulti) { b.dataset.sqinMulti = '1'; b.textContent = 'Elegir tallas'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', label); else label();
  new MutationObserver(label).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.js-btn-size');
    if (!b || !multi(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = b.closest('.card-product');
    var a = card && card.querySelector('a[href*="/products/"]');
    /* En móvil el panel de tallas se abre fuera de la tarjeta: se busca la tarjeta por la variante */
    if (!a && b.dataset.variantid) {
      var src = document.querySelector('.card-product .js-btn-size[data-variantid="' + b.dataset.variantid + '"]');
      var c2 = src && src.closest('.card-product');
      a = c2 && c2.querySelector('a[href*="/products/"]');
    }
    if (a) location.href = a.href;
    else if (b.dataset.variantid) location.href = '/variants/' + b.dataset.variantid;
  }, true);
})();

/* Ficha, móvil: "Mismo estilo" en cuadrícula -> se desactiva el carrusel (Swiper) para que funcione el deslizado de fotos de cada tarjeta */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function apply() {
    if (!document.body || !document.body.classList.contains('template--product')) return;
    document.querySelectorAll('card-product-slider.swiper').forEach(function (el) {
      var s = el.swiper;
      if (!s) return;
      if (mq.matches && s.enabled) { s.disable(); s.setTranslate(0); }
      else if (!mq.matches && !s.enabled) { s.enable(); }
    });
  }
  function run() { apply(); setTimeout(apply, 800); setTimeout(apply, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) { var t = list[i].target; if (t.classList && t.classList.contains('swiper-initialized')) { apply(); return; } }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* Ficha: el extracto se muestra sin el ✔️ del inicio (el texto del metacampo no se toca) */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function clean() {
    document.querySelectorAll('.product__content .product__text--body').forEach(function (p) {
      p.childNodes.forEach(function (n) { if (n.nodeType === 3) n.textContent = n.textContent.replace(/^\s*✔️?\s*/, ''); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean); else clean();
})();

/* Ficha: "Flash Sale" sobre la foto (el tema solo lo pinta en productos rebajados).
   La copia de la foto NO lleva la clase .pdp-badge-flash: si la llevara, el script que coloca
   la etiqueta junto al precio la movería ahí y se irían acumulando varias "Flash Sale". */
(function () {
  if (!document.body.classList.contains('template--product')) return;
  function place() {
    document.querySelectorAll('.price .sqin-flash-media').forEach(function (x) { x.remove(); });
    var f = document.querySelector('.product__content .pdp-badge-flash:not(.sqin-flash-media)');
    var m = document.querySelector('.product__media');
    if (!f || !m || m.querySelector('.sqin-flash-media')) return;
    var c = f.cloneNode(true);
    c.classList.remove('pdp-badge-flash');
    c.classList.add('sqin-flash-media');
    c.style.cssText = 'position:absolute;bottom:14px;left:14px;z-index:5;display:inline-block;background:#111;color:#fff;font-size:10px;letter-spacing:.05em;text-transform:uppercase;padding:4px 8px;font-weight:400;white-space:nowrap;font-family:Helvetica,Arial,sans-serif;pointer-events:none';
    m.appendChild(c);
  }
  function run() { place(); setTimeout(place, 1000); setTimeout(place, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
